<script setup>
import {onMounted,reactive} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const data = reactive({
  search: null,
  items: [],
  loading: true,
  headers: [
    {
      title: 'Client',
      align: 'left',
      key: 'insurance_company',
    },
    {
      title: 'Current',
      key: 'current',
    },
    {
      title: '0-30 Days',
      key: 'total30',
    },
    {
      title: '31-60 Days',
      key: 'total60',
    },
    {
      title: '61-90 Days',
      key: 'total90',
    },
    {
      title: '91-180 Days',
      key: 'total180',
    },
    {
      title: 'Over 180 Days',
      key: 'totalover',
    },
    {
      title: 'Total For Client',
      key: 'totalall',
    },
  ],
});

const getData = () => {
  data.loading = true;
  ApiWrapper.post('reports', 'client-invoice-by-age-report', {})
      .then((response) => {
        let items = response.data;

        for(let x in items) {
          items[x].current = Math.round((items[x].current * 100), 2) / 100
          items[x].total30 = Math.round((items[x].total30 * 100), 2) / 100
          items[x].total60 = Math.round((items[x].total60 * 100), 2) / 100
          items[x].total90 = Math.round((items[x].total90 * 100), 2) / 100
          items[x].total180 = Math.round((items[x].total180 * 100), 2) / 100
          items[x].totalover = Math.round((items[x].totalover * 100), 2) / 100
        }

        let total = {
          insurance_company: 'Total All Clients',
          current: 0.00,   //invoices not overdue
          total30: 0.00,
          total60: 0.00,
          total90: 0.00,
          total180: 0.00,
          totalover: 0.00,
          totalall: 0.00
        }

        for(let x in items) {
          total.current += items[x].current
          total.total30 += items[x].total30
          total.total60 += items[x].total60
          total.total90 += items[x].total90
          total.total180 += items[x].total180
          total.totalover += items[x].totalover
        }

        total.current = Math.round(total.current * 100, 2) / 100
        total.total30 = Math.round(total.total30 * 100, 2) / 100
        total.total60 = Math.round(total.total60 * 100, 2) / 100
        total.total90 = Math.round(total.total90 * 100, 2) / 100
        total.total180 = Math.round(total.total180 * 100, 2) / 100
        total.totalover = Math.round(total.totalover * 100, 2) / 100
        total.totalall = Math.round((total.current + total.total30 + total.total60 + total.total90 + total.total180 + total.totalover) * 100, 2) / 100

        items.push(total)

        data.items = items;
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.loading = false;
      });
}

const format = (num) => {
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return formatter.format(num);
}

const formatISODateToAmerican = (date) => {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${month}/${day}/${year}`;
}

const csvExport = () => {
  // CSV File
  let csvContent = 'data:text/csv;charset=utf-8,';
  let arrData = data.items;

  csvContent += [
    Object.keys(arrData[0]).join(','),
    ...arrData.map((item) => Object.values(item).join(',')),
  ]
  .join('\n')
  .replace(/(^\[)|(\]$)/gm, '');

  let csvData = encodeURI(csvContent);
  const link = document.createElement('a');
  link.setAttribute('href', csvData);
  link.setAttribute('download', 'ClientInvoiceByAgeReport.csv')
  link.click();
}

onMounted(() => {
  getData();
});

</script>

<template>
  <v-container id="entreos-resize-target" fluid>
    <v-card>
      <v-toolbar dense flat color="white">
        <v-toolbar-title>Client Invoices By Age Report</v-toolbar-title>
        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        ></v-progress-linear>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn
            size="small"
            variant="elevated"
            color="success"
            @click="csvExport()"
        >
          <v-icon class="mr-2">mdi-file-download</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
        <v-text-field class="px-5" label="Search" v-model="data.search"></v-text-field>
      </v-toolbar>

      <v-data-table
          density="compact"
          :items="data.items"
          :headers="data.headers"
          :search="data.search"
          :loading="data.loading"
          :items-per-page="-1"
          loading-text="Loading... Please wait"
      >
        <template v-slot:[`item.current`]="{ item }">
          {{format(item.current)}}
        </template>
        <template v-slot:[`item.total30`]="{ item }">
          {{format(item.total30)}}
        </template>
        <template v-slot:[`item.total60`]="{ item }">
          {{format(item.total60)}}
        </template>
        <template v-slot:[`item.total90`]="{ item }">
          {{format(item.total90)}}
        </template>
        <template v-slot:[`item.total180`]="{ item }">
          {{format(item.total180)}}
        </template>
        <template v-slot:[`item.totalover`]="{ item }">
          {{format(item.totalover)}}
        </template>
        <template v-slot:[`item.totalall`]="{ item }">
          {{format(item.totalall)}}
        </template>
      </v-data-table>

    </v-card>
  </v-container>

</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
.v-toolbar__title {
  font-size: 1rem !important;
}
</style>